import { SSF } from "xlsx";
import { AddCustomerData } from "../store/slices/customers/types";
import {
  InvoiceCSVHeaders,
  InvoiceData,
} from "../store/slices/invoicing/types";

export const mapCSVData: (
  data: string[][],
  email_address: string,
  phone_number: string,
  location_name: string
) => AddCustomerData[] = (data, email_address, phone_number, location_name) => {
  return data.slice(1).map((row) => ({
    location_name: location_name
      ? row[data[0].indexOf(location_name)] || null
      : null,
    email_address: row[data[0].indexOf(email_address)] || null,
    phone_number: row[data[0].indexOf(phone_number)] || null,
  }));
};

export const mapInvoiceCSVData: (
  data: string[][],
  headers: InvoiceCSVHeaders
) => Omit<InvoiceData, "id">[] = (data, headers) => {
  return data.slice(1).map((row) => {
    const rawDueDate = row[data[0].indexOf(headers.due_date)];
    const rawInvoiceDate = row[data[0].indexOf(headers.invoice_date)];
    let dueDate = rawDueDate;
    let invoiceDate = rawInvoiceDate;
    // Unary + operator converts to a number
    if (rawDueDate && !isNaN(+rawDueDate)) {
      const ssfDueDate = SSF.parse_date_code(
        parseFloat(row[data[0].indexOf(headers.due_date)])
      );
      dueDate = `${ssfDueDate.d}-${ssfDueDate.m}-${ssfDueDate.y}T${ssfDueDate.H}:${ssfDueDate.M}:${ssfDueDate.S}`;
    }
    if (rawInvoiceDate && !isNaN(+rawInvoiceDate)) {
      const ssfInvoiceDate = SSF.parse_date_code(
        parseFloat(row[data[0].indexOf(headers.invoice_date)])
      );
      invoiceDate = `${ssfInvoiceDate.d}-${ssfInvoiceDate.m}-${ssfInvoiceDate.y}T${ssfInvoiceDate.H}:${ssfInvoiceDate.M}:${ssfInvoiceDate.S}`;
    }
    return {
      invoice_number: row[data[0].indexOf(headers.invoice_number)],
      amount: parseFloat(row[data[0].indexOf(headers.amount)]),
      invoice_date: invoiceDate || null,
      due_date: dueDate || null,
      client_name: row[data[0].indexOf(headers.client_name)] || "",
      client_email: row[data[0].indexOf(headers.client_email)] || "",
      client_phone_number:
        row[data[0].indexOf(headers.client_phone_number)] || "",
      comments: row[data[0].indexOf(headers.comments)] || "",
    };
  });
};
